import Dialog from "../dialogs";

const ConfirmationModal = ({ isOpen, onClose, onConfirm, loading }) => {
  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      width="570px"
      className="!bg-[#FFFFFF] !ring-1 !ring-[#D9D9D9]"
    >
      <div onClick={(e) => e.stopPropagation()}>
        <h3 className="text-xl font-bold text-gray-900">Confirmation</h3>
        <p className="mt-2 text-sm text-gray-500">
          Are you sure to cancel the order?
        </p>
        <div className="mt-6 flex justify-end gap-4">
          <button
            onClick={onClose}
            className="px-6 py-2 text-sm font-semibold text-[#4F378A] ring-1 ring-[#4F378A] !bg-transparent rounded-lg transition-colors"
          >
            Nope
          </button>
          <button
            disabled={loading}
            onClick={onConfirm}
            className="px-6 py-2 text-sm font-semibold text-white bg-red-600 hover:bg-red-700 rounded-lg transition-colors"
          >
            {loading ? "Cancelling Order..." : "Yes, Cancel"}
          </button>
        </div>
      </div>
    </Dialog>
  );
};

export default ConfirmationModal;
